import { createApp, ref } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { tryParseJSON } from '@/helpers/parse-json'

// Components
import contactForm from '@/pages/retailer/contact-form.vue'

const app = document.getElementById("contact-form")

createApp(contactForm, { retailer: tryParseJSON(app.getAttribute('retailer')), retailerType: app.getAttribute('retailer-type') }).use(VueReCaptcha, { siteKey: window.af_reCaptchaSiteKey }).mount('#contact-form')
